"use client";

import { useEffect, useRef } from 'react';
import { Card, CardContent } from './ui/card';
import React from 'react';
import { cn } from '../lib/utils';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { ApplyOnlineForm } from './apply-online-form';
import { EnquireNowForm } from './enquire-now-form';
import { ContactInfo } from './contact-info';
import { ServiceData } from '../types/service';
import { observer } from 'mobx-react-lite';// Import your KSA form component
import { BookingKsaForm } from '../feature-module/booking/BookingKsaResident';
import BookingResort from '../feature-module/booking/BookingResort';

interface InquirySidebarProps {
  visaOptions: ServiceData[];
  selectedVisa?: ServiceData;
  highlight?: boolean;
}

export function InquirySidebar({ visaOptions, selectedVisa, highlight }: InquirySidebarProps) {
    const cardRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (highlight) {
            cardRef.current?.classList.add('shadow-primary/50', 'shadow-2xl');
            setTimeout(() => {
                cardRef.current?.classList.remove('shadow-primary/50', 'shadow-2xl');
            }, 1500);
        }
    }, [highlight]);
    
    useEffect(() => {
    }, [selectedVisa]);

    // Check if selected visa is KSA
    const isKsaVisa = selectedVisa?.name === "Tourist Visa KSA";
    const isResort = selectedVisa?.name === "Resort - Ras Al Khaimah";

    return (
        <Card 
            ref={cardRef}
            className={cn(
                "!border !border-[#e71875] bg-white  transition-all duration-500 ease-out",
                highlight ? "ring-4 ring-primary/30 ring-offset-2" : ""
            )}
        >
            <CardContent className="p-0">
                <Tabs defaultValue="apply" className="w-full">
                    <TabsList className="grid w-full grid-cols-2 rounded-t-xl rounded-b-none h-auto p-0">
                        <TabsTrigger value="apply" className="py-3 text-base data-[state=active]:bg-[#e71875] data-[state=active]:text-primary-foreground rounded-tl-xl rounded-br-none rounded-tr-none rounded-bl-none">Apply Online</TabsTrigger>
                        <TabsTrigger value="enquire" className="py-3 text-base data-[state=active]:bg-[#e71875] data-[state=active]:text-primary-foreground rounded-tr-xl rounded-bl-none rounded-tl-none rounded-br-none">Enquire Now</TabsTrigger>
                    </TabsList>
                    <div className="p-4 md:p-6">
                      <TabsContent value="apply" className="m-0">
                          {isKsaVisa ? (
                              <BookingKsaForm service={selectedVisa} />
                          ) : isResort? (
                              <BookingResort  service={selectedVisa!} />
                          ): (
                              <ApplyOnlineForm services={visaOptions} selectedService={selectedVisa!} />
                          )}
                      </TabsContent>
                      <TabsContent value="enquire" className="m-0">
                      <ContactInfo />
                      </TabsContent>
                    </div>
                </Tabs>
            </CardContent>
        </Card>
    );
}
export default observer(InquirySidebar);